import React from "react";
import styles from "./styles.module.css"; // Import the CSS module

const Register = () => {
  return (
    <div className={styles.container}>
      <div className={styles["login-box"]}>
        <form className={styles.form}>
          <div className={styles.logo}></div>
          <span className={styles.header}>Create an Account</span>
          <input type="email" placeholder="Email" className={styles.input} />
          <input type="password" placeholder="Password" className={styles.input} />
          <input type="password" placeholder="Confirm Password" className={styles.input} />
          <button type="submit" className={`${styles.button} ${styles["sign-in"]}`}>Sign Up</button>
          

          <p className={styles.footer}>
            Already have an account?
            <a href="/login" className={styles.link}> Log in here </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
